// ============================================================
// 临时主题预览工具（不入生产 UI，用完即删）。
// 打开方式：任意页面 URL 加 ?theme-preview=1（可选 &theme=<id> 直接应用）。
// 删除方式：移除本文件与 __root.tsx 中的挂载即可。
// ============================================================

import { useEffect, useMemo, useState } from 'react';

import { cn } from '@/lib/utils';

import { themes, type ThemeId } from './theme-config';
import { applyThemeTokens } from './theme-mapper';

function readInitialTheme(): ThemeId {
  if (typeof window === 'undefined') return 'status-quo';
  const fromUrl = new URLSearchParams(window.location.search).get('theme');
  return fromUrl !== null && fromUrl in themes ? (fromUrl as ThemeId) : 'status-quo';
}

export function ThemeSwitcher() {
  const [active, setActive] = useState<ThemeId>(readInitialTheme);
  const themeIds = useMemo(
    () => Object.keys(themes) as ThemeId[],
    [],
  );

  useEffect(() => {
    applyThemeTokens(active);
  }, [active]);

  return (
    <div
      data-theme-switcher="dev-preview"
      className="fixed right-4 bottom-4 z-[9999] w-64 rounded-xl border border-border bg-popover p-3 text-popover-foreground shadow-lg"
    >
      <p className="mb-2 text-xs font-medium text-muted-foreground">
        主题预览（临时 · T = status-quo）
      </p>
      <div className="grid grid-cols-4 gap-1.5">
        {themeIds.map((id) => (
          <button
            key={id}
            type="button"
            data-theme-id={id}
            aria-pressed={active === id}
            onClick={() => setActive(id)}
            className={cn(
              'h-8 rounded-md border text-xs font-medium transition-colors',
              active === id
                ? 'border-ring bg-primary text-primary-foreground'
                : 'border-border bg-background text-foreground hover:bg-muted',
            )}
          >
            {id === 'status-quo' ? 'T' : id.toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  );
}
